<template>
  <div class="OMStatus">
    <modal
      name="UpdateStatusConf"
      width="30%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      style="overflow:scroll"
    >
       <div class="container">
        <div class="confirm">Este listado será enviado a nuestro sistema para ser procesado, una vez ejecutado no podrá volverse a modificar esta segur@ de esta acción?</div>
        <div class="botoPnrocess">
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <button
                  id="UpdateConfirm"
                  type="submit"
                  v-on:click="FinalUpdateStatus"
                  class="loginbtn primaryBtn"
                >Confirmar</button>
              </div>
              <div class="col-md-6">
                <button
                  id="CancelConfirm"
                  type="submit"
                  v-on:click="CancelStatus"
                  class="loginbtn primaryBtn"
                >Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="UpdateStatusActu"
      width="30%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      style="overflow:scroll"
    >
       <div class="container">
        <div class="confirm">Este listado será actualizado, podra volver a modificarlo en cualquier momento esta segur@ de esta acción?</div>
        <div class="botoPnrocess">
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <button
                  id="UpdateUpdate"
                  type="submit"
                  v-on:click="ConfirmStatus"
                  class="loginbtn primaryBtn"
                >Actualizar</button>
              </div>
              <div class="col-md-6">
                <button
                  id="CancelUpdate"
                  type="submit"
                  v-on:click="CancelStatus"
                  class="loginbtn primaryBtn"
                >Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="UpdateStatus"
      width="80%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      style="overflow:scroll"
    >
    <div class="container">
        <div class="content">
        <FormListOrdersStatus
          :InfoView="this.statusUpdate"
          :HeadTable="this.HDPersons"
          :method="processData"
          v-if="renderComponent2"
        />
        </div>
        <div class="botoPnrocess">
          <div class="container">
            <div class="row">
              <div class="col-md-2">
                <button
                  id="ConfirmUser"
                  type="submit"
                  v-on:click="FinalSendStatus"
                  class="loginbtn primaryBtn"
                >Confirmar</button>
              </div>
              <div class="col-md-6"></div>
              <div class="col-md-2">
                <button
                  id="UpdateUser"
                  type="submit"
                  v-on:click="UpdateStatus"
                  class="loginbtn primaryBtn"
                >Actualizar</button>
              </div>
              <div class="col-md-2">
                <button
                  id="CancelUser"
                  type="submit"
                  v-on:click="CancelStatus"
                  class="loginbtn primaryBtn"
                >Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div class="titlePage">Detalle Ordenes de Matricula</div>
    <div v-if="this.dataOMInf">
      <div class="text-center">
        <button
          type="submit"
          class="loginbtn primaryBtn"
          v-on:click="this.processStatus"
          v-if="this.$store.state.PeriodProccess.Sta_Step <= 2"
        >Actualizar Estados de Estudiantes</button>
      </div>
      <va-notification color="danger" v-if="refNoReport" class="refNoData">El servicio que ejecuta el reporte no se encuentra activo.</va-notification>
      <va-notification color="info" v-if="addUpdateExito" class="refNoData">Se genero correctamente la actualización de los estudiantes modificados.</va-notification>
      <va-notification color="info" v-if="addAprovExito" class="refNoData">Se genero correctamente la tarea para actualizar los estados de los estudiantes, una vez finalizada esta tarea se le informar al correo  la activación.</va-notification>
      <div class="Separador"></div>
      <div class="OrderListData">
        <FormListOrders
          :InfoView="this.DLPersons"
          :HeadTable="this.HDPersons"
          :filterData="this.FilterData"
          :method="processData"
          v-if="renderComponent1"
        />
      </div>
      <div class="text-center">
        <button
          type="submit"
          class="loginbtn primaryBtn"
          v-on:click="this.processStatus"
          v-if="this.$store.state.PeriodProccess.Sta_Step <= 2"
        >Actualizar Estados de Estudiantes</button>
      </div>
    </div>
    <div v-else>
      <va-notification
        color="danger"
        class="refNoData"
      >No se encontró información de Ordenes de Matricula activas.</va-notification>
    </div>
  </div>
</template>

<script>
import FormListOrders from '@/components/data-tables/DataPersons.vue'
import FormListOrdersStatus from '@/components/data-tables/DataPersonsStatus.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'OMStatus',
  data () {
    return {
      HDPersons: [
        {
          name: 'idBanner',
          title: 'Id Banner',
          width: '10%',
        },
        {
          name: 'documentType',
          title: 'Tipo Identificación',
          width: '15%',
        },
        {
          name: 'documentNumber',
          title: 'Num Identificación',
          width: '15%',
        },
        {
          name: 'namPerson',
          title: 'Nombres',
          sortField: 'namPerson',
          width: '10%',
        },
        {
          name: 'lastNamePerson',
          title: 'Apellidos',
          sortField: 'lastNamePerson',
          width: '10%',
        },
        {
          name: 'typeStudent',
          title: 'Tipo Estudiante',
          width: '10%',
        },
        {
          name: 'namProgram',
          title: 'Programa',
          width: '10%',
        },
        {
          name: '__slot:Banner',
          title: 'Estado Banner',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Estado',
              icon: 'fa-check',
              action: 'status_user',
            },
          ],
        },
      ],
      DLPersons: [],
      renderComponent1: false,
      renderComponent2: false,
      refNoReport: false,
      addUpdateExito: false,
      addAprovExito: false,
      dataOMInf: true,
      statusUpdate: [],
      FilterData: [
        {
          ListPrograms: [],
          ListEstudent: [],
        },
      ],
    }
  },
  components: {
    FormListOrders,
    FormListOrdersStatus,
  },
  created: function () {
    if (this.$store.state.PeriodProccess.Id_LoadView === undefined) {
      this.dataOMInf = false
      return false
    }
    let loader = this.$loading.show()
    var datainf = IberoHelpers.getStatusOM(
      this.$store,
      this.$store.state.PeriodProccess.Id_LoadView
    )
    datainf.then(Response => {
      this.DLPersons = Response.data
      this.FilterData.ListEstudent = IberoHelpers.uniqueBy(
        Response.data,
        'typeStudent'
      )
      this.FilterData.ListPrograms = IberoHelpers.uniqueBy(
        Response.data,
        'namProgram'
      )
      IberoHelpers.forceRerender1(this)
      loader.hide()
    })
  },
  methods: {
    clearMSN () {
      this.refNoReport = false
      this.addUpdateExito = false
      this.addAprovExito = false
    },
    FinalUpdateStatus () {
      this.clearMSN()
      let loader = this.$loading.show()
      this.CancelStatus()
      this.ConfirmStatus()
      var UpdateFinStatus = IberoHelpers.sendStatusOMFinal(this.$store)
      UpdateFinStatus.then(Response => {
        if (Response.data.status === '200') {
          this.addAprovExito = true
          this.renderComponent2 = false
          this.statusUpdate.length = 0
          loader.hide()
        } else {
          this.refNoReport = true
          loader.hide()
        }
      })
    },
    ConfirmStatus () {
      this.clearMSN()
      let loader = this.$loading.show()
      this.CancelStatus()
      var UpdateOMStatus = IberoHelpers.sendStatusOM(this.$store, this.$store.state.PeriodProccess.Id_LoadView, this.$session.get('IberoJWTAdminLogin').idPerson, this.statusUpdate)
      UpdateOMStatus.then(Response => {
        if (Response.data.status === '200') {
          this.addUpdateExito = true
          this.renderComponent2 = false
          this.statusUpdate.length = 0
          loader.hide()
        } else {
          this.refNoReport = true
          loader.hide()
        }
      })
    },
    FinalSendStatus () {
      this.clearMSN()
      this.$modal.hide('UpdateStatus')
      this.$modal.show('UpdateStatusConf')
    },
    UpdateStatus () {
      this.clearMSN()
      this.$modal.hide('UpdateStatus')
      this.$modal.show('UpdateStatusActu')
    },
    CancelStatus () {
      this.clearMSN()
      this.$modal.hide('UpdateStatus')
      this.$modal.hide('UpdateStatusConf')
      this.$modal.hide('UpdateStatusActu')
    },
    processStatus: function () {
      this.clearMSN()
      if (this.statusUpdate.length >= 1) {
        IberoHelpers.forceRerender2(this)
        this.$modal.show('UpdateStatus')
      } else {
        this.FinalSendStatus()
      }
    },
    processData: function (event, actionref) {
      this.clearMSN()
      if (event.rowData.staNextPeriod === true) {
        event.rowData.staNextPeriod = false
      } else {
        event.rowData.staNextPeriod = true
      }
      var refFind = this.statusUpdate.findIndex(
        element =>
          element.idViewTuitionPeriod === event.rowData.idViewTuitionPeriod
      )
      if (refFind === -1) {
        this.statusUpdate.push(event.rowData)
      } else {
        this.statusUpdate.splice(refFind, 1)
      }
    },
  },
}
</script>

<style scoped>
.refNoData {
  padding: 10px;
  padding-left: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.container {
  max-width: 98%;
  min-width: 98%;
  margin: 10px auto;
  font-family: "Montserrat", sans-serif;
  color: #888;
}
.botoPnrocess {
  text-align: center;
  margin-top: -10px;
  margin-bottom: 30px;
}
.loginbtn primaryBtn{
  width: 90%;
}
.content {
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  overflow-y: scroll;
  height: 500px;
}
.Separador{
  margin-top: 30px;
}
</style>
